var exports = {
  "zr": "IncomingCallUI.module__root___VWRESm",
  "Nr": "IncomingCallUI.module__card___VWRESm",
  "BU": "IncomingCallUI.module__dragHandle___VWRESm",
  "IH": "IncomingCallUI.module__dragPill___VWRESm",
  "t$": "IncomingCallUI.module__stack___VWRESm",
  "wx": "IncomingCallUI.module__header___VWRESm",
  "nr": "IncomingCallUI.module__headerIcon___VWRESm",
  "my": "IncomingCallUI.module__avatar___VWRESm",
  "_0": "IncomingCallUI.module__ic-ring-pulse___VWRESm",
  "sI": "IncomingCallUI.module__callerInfo___VWRESm",
  "XF": "IncomingCallUI.module__callerName___VWRESm",
  "_n": "IncomingCallUI.module__callerSubtitle___VWRESm",
  "o1": "IncomingCallUI.module__actions___VWRESm",
  "mH": "IncomingCallUI.module__actionGroup___VWRESm",
  "T$": "IncomingCallUI.module__circleButton___VWRESm",
  "FM": "IncomingCallUI.module__circleButtonAccept___VWRESm",
  "cK": "IncomingCallUI.module__circleButtonReject___VWRESm",
  "V6": "IncomingCallUI.module__circleButtonIconRotated___VWRESm",
  "ZJ": "IncomingCallUI.module__actionLabel___VWRESm",
  "rw": "IncomingCallUI.module__ignoreLink___VWRESm",
  "IR": "IncomingCallUI.module__screenReaderOnly___VWRESm",
  "Po": "IncomingCallUI.module__bottomSheetStack___VWRESm",
};

module.exports = exports;
